import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VRow,[_c(VCol,{attrs:{"cols":"12"}},[_c('div',{staticClass:"text-center text-h3"},[_vm._v(" Reporte de Rendimiento de Operadores ")]),(_vm.cargando)?_c(VProgressLinear,{attrs:{"indeterminate":"","color":"blue darken-2"}}):_vm._e(),_c('Bar',{attrs:{"chart-options":_vm.chartOptions,"chart-data":_vm.chartData}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }